import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs, OverlayTrigger, Tooltip} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { formatarValor, formatarValorAPI, tiposServicos } from '../../common/utils';
import { withRouter } from '../../common/with-router';
import AsyncSelect from 'react-select/async';
import { FaArrowDown, FaArrowUp, FaCheck, FaTimes, FaStream, FaNotesMedical, FaArrowLeft, FaEye, FaTrash, FaQuestionCircle } from "react-icons/fa";
import { NumericFormat } from 'react-number-format';
import ServicosConfiguracoes from './ServicosConfiguracoes';

// O que cada opção liga no sistema — dica de tela, para não habilitar no programa errado.
const AJUDA_OPCOES = {
    monitoramento: 'Ao confirmar a realização, passa a exigir o anexo do relatório de monitoramento em PDF, e o sistema lê os indicadores do aparelho e grava no atendimento. A leitura é específica do relatório "VNS Therapy Session Report" (LivaNova): não habilite em serviços de outros programas, pois nenhum outro relatório é reconhecido.',
    video_conferencia: 'O agendamento passa a ser atendido por vídeo chamada, exibindo o link da sala. Serviços marcados assim não aparecem na solicitação de exames.',
    logistica: 'Para serviços de transporte/entrega: quem confirma a realização precisa informar o valor do serviço. Ao marcar "Sim", a opção "Permite alterar valor do agendamento" também é ligada.',
    termo_aceite: 'Habilita o envio do Termo PDF do serviço (campo abaixo) e passa a exigir o aceite do termo no agendamento.',
    alterar_valor: 'Libera a edição do valor no agendamento — sem isso o campo fica somente leitura, com o valor padrão do serviço. Na confirmação da realização o valor passa a ser obrigatório.',
    ocultar_exames: 'O serviço deixa de aparecer na lista de solicitação de exames. Use para serviços que não são pedidos como exame.',
    terapia: 'No agendamento, passa a exigir o vínculo com uma terapia do histórico do paciente (lote, validade e dose).',
    atendimento_frustrado: 'Na confirmação da realização, libera marcar que o atendimento foi frustrado (o profissional compareceu mas o atendimento não aconteceu). Ao marcar, a observação passa a ser obrigatória, os arquivos de evidência (monitoramento e laudo) deixam de ser exigidos e o valor cobrado é reduzido para o percentual informado ao lado, que passa a ser obrigatório.',
};

// trigger inclui click porque no celular não existe hover
const ajudaOpcao = (texto) => (
    <OverlayTrigger placement="auto" trigger={['hover', 'focus', 'click']} overlay={<Tooltip className="tooltip-ajuda">{texto}</Tooltip>}>
        <span className="ms-1 text-secondary" role="button" tabIndex={0} style={{ cursor: 'help' }}>
            <FaQuestionCircle />
        </span>
    </OverlayTrigger>
);

class ServicosEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);

        this.enviaRegistro = this.enviaRegistro.bind(this);

        this.fileInput = React.createRef();        
        this.fileInputRef = React.createRef();

        this.state = {
            nome: '',
            descricao: '',
            tipo: '',
            valor: '',
            erroLoadRegistro: "",
            servico_id: "",
            titulo_pagina: "",
            servico_dados_monitoramento: false,
            servico_video_conferencia: false,
            servico_logistica: false,
            servico_terapia: false,
            prestadores: [],            
            exige_termo_aceite: false,
            ocultar_solicitacao_exames: false,
            permite_alterar_valor_agendamento: false,
            permite_atendimento_frustrado: false,
            percentual_cobranca_frustrado: '',
            percentualCobrancaFrustradoHelper: '',
            termo_aceite_pdf: '',
            termo_aceite_pdf_upload: '',
            termoAceitePDFHelper: '',
            excluir_pdf: false,
            loading: false,
            vinculos_doencas: [],
            doenca_selecionada: null,
            is_active: true,
        };
    }

    componentDidMount(){
        const id = this.props.router.params.id;

        if(id){
            this.setState({
                servico_id: id,
                titulo_pagina: 'Editando Serviço/Procedimento',
                loading: true,
                erroLoadRegistro: ''
            })

            api.get(`/servicos_procedimentos/${id}`)
            .then(response => {
                const dados = response.data;

                //preenche os inputs
                this.setState({
                    erroLoadRegistro: '',
                    nome: dados.nome,
                    descricao: dados.descricao,
                    tipo: dados.tipo,
                    valor: dados.valor,
                    servico_dados_monitoramento: dados.servico_dados_monitoramento,
                    servico_video_conferencia: dados.servico_video_conferencia,
                    servico_logistica: dados.servico_logistica,
                    servico_terapia: dados.servico_terapia,
                    exige_termo_aceite: dados.exige_termo_aceite,
                    permite_alterar_valor_agendamento: dados.permite_alterar_valor_agendamento,
                    permite_atendimento_frustrado: !!dados.permite_atendimento_frustrado,
                    percentual_cobranca_frustrado: dados.percentual_cobranca_frustrado ?? '',
                    ocultar_solicitacao_exames: dados.ocultar_solicitacao_exames,
                    termo_aceite_pdf: typeof dados.termo_aceite_pdf === 'string' ? dados.termo_aceite_pdf : '',
                    is_active: !!dados.is_active,
                    titulo_pagina: `Editando Serviço/Procedimento: ${dados.nome}`,
                    loading: false
                })

                this.carregarPrestadoresServico();
                this.carregarDoencasVinculadas(id)
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar serviço/procedimento, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
        else {
            this.setState({
                servico_id: '',
                titulo_pagina: 'Adicionar Serviço/Procedimento',
                loading: false,
                erroLoadRegistro: '',
            })
        }
    }

    enviaRegistro = (e) => {
        e.preventDefault();

        //sem percentual a marcação de frustrado cobraria o valor integral em silêncio, que é
        //justamente o oposto do que a opção se propõe a fazer
        if (this.state.permite_atendimento_frustrado && String(this.state.percentual_cobranca_frustrado ?? '') === '') {
            this.setState({ percentualCobrancaFrustradoHelper: 'Informe o percentual cobrado quando o atendimento for frustrado.' });
            return;
        }

        const formData = new FormData();

        this.setState({
            loading: true,
            nomeHelper: "",
            descricaoHelper: "",
            tipoHelper: "",
            valorHelper: "",
            percentualCobrancaFrustradoHelper: "",
        });

        const valorFormatadoAPI = (this.state.valor) ? formatarValorAPI(this.state.valor) : 0;

        //vererifica se é edição ou adição
        const url = (this.state.servico_id) ? '/servicos_procedimentos/'+this.state.servico_id+'/' : '/servicos_procedimentos/'
        const metodo = (this.state.servico_id) ? 'put' : 'post'

        formData.append('nome', this.state.nome);
        formData.append('descricao', this.state.descricao || "");
        formData.append('tipo', this.state.tipo);
        formData.append('valor', valorFormatadoAPI);
        formData.append('servico_dados_monitoramento', this.state.servico_dados_monitoramento);
        formData.append('servico_video_conferencia', this.state.servico_video_conferencia);
        formData.append('servico_logistica', this.state.servico_logistica);
        formData.append('servico_terapia', this.state.servico_terapia);
        if (this.state.termo_aceite_pdf_upload) {
            formData.append('termo_aceite_pdf', this.state.termo_aceite_pdf_upload);
        }
        formData.append('exige_termo_aceite', this.state.exige_termo_aceite);
        formData.append('permite_alterar_valor_agendamento', this.state.permite_alterar_valor_agendamento);
        formData.append('permite_atendimento_frustrado', this.state.permite_atendimento_frustrado);
        formData.append('ocultar_solicitacao_exames', this.state.ocultar_solicitacao_exames);
        formData.append('is_active', this.state.is_active ? 'true' : 'false');

        //o percentual só faz sentido com a opção ligada; vazio limpa o valor gravado
        if (this.state.permite_atendimento_frustrado && String(this.state.percentual_cobranca_frustrado) !== '') {
            formData.append('percentual_cobranca_frustrado', formatarValorAPI(this.state.percentual_cobranca_frustrado));
        } else {
            formData.append('percentual_cobranca_frustrado', '');
        }

        if (this.state.excluir_pdf) {
            formData.append('excluir_pdf', true);
        }

        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            const MySwal = withReactContent(Swal);
            const dados = response.data;

            const textSwal = (this.state.servico_id) ? 'Serviço/Procedimento atualizado com sucesso' : 'Serviço/Procedimento cadastrado com sucesso';

            // Atualiza o estado com os dados retornados da API
            this.setState({
                loading: false,
                termo_aceite_pdf: typeof dados.termo_aceite_pdf === 'string' ? dados.termo_aceite_pdf : '',
                termo_aceite_pdf_upload: '',
                excluir_pdf: false,
                nome: dados.nome,
                descricao: dados.descricao,
                tipo: dados.tipo,
                valor: dados.valor,
                exige_termo_aceite: dados.exige_termo_aceite,
                permite_alterar_valor_agendamento: dados.permite_alterar_valor_agendamento,
                permite_atendimento_frustrado: !!dados.permite_atendimento_frustrado,
                percentual_cobranca_frustrado: dados.percentual_cobranca_frustrado ?? '',
                ocultar_solicitacao_exames: dados.ocultar_solicitacao_exames,
                servico_dados_monitoramento: dados.servico_dados_monitoramento,
                servico_video_conferencia: dados.servico_video_conferencia,
                servico_logistica: dados.servico_logistica,
                servico_terapia: dados.servico_terapia,
                is_active: !!dados.is_active,
            });

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
            })
            
            //redireciona
            if(!this.state.servico_id){
                this.props.router.navigate("/servicos");
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o serviço/procedimento, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'nome'){
                        this.setState({ nomeHelper: value })
                    }
                    if(key === 'descricao'){
                        this.setState({ descricaoHelper: value })
                    }
                    if(key === 'tipo'){
                        this.setState({ tipoHelper: value })
                    }
                    if(key === 'valor'){
                        this.setState({ valorHelper: value })
                    }
                    if(key === 'percentual_cobranca_frustrado'){
                        this.setState({ percentualCobrancaFrustradoHelper: value })
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };
    
    toggleStatusAtivo = () => {
        if (!this.state.servico_id) {
            this.setState({ is_active: !this.state.is_active });
            return;
        }

        const novo_status = !this.state.is_active;
        this.setState({ loading: true });

        api.put(`/servicos_procedimentos/${this.state.servico_id}/`, {
            is_active: novo_status
        })
        .then(response => {
            const MySwal = withReactContent(Swal);
            this.setState({
                is_active: !!response.data.is_active,
                loading: false
            });
            MySwal.fire({
                title: <p>Status atualizado com sucesso</p>,
                icon: 'success',
                showCloseButton: true,
            });
        })
        .catch(error => {
            this.setState({ loading: false });
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: <p>Erro ao atualizar status</p>,
            });
        });
    }

    handleChange = (e, inputName) => {
        const { name, value } = e.target;
        if (name === "valor") {
            const valorFormatado = formatarValor(value);
            this.setState({ [name]: valorFormatado });
        } else {
            this.setState({ [name]: value });
        }
    };

    //Prestadores do serviço
    carregarPrestadoresServico = () => {
        if (this.state.servico_id) {
            api.get(`/pessoas/prestadores/servicos_procedimentos/?servico_procedimento_id=${this.state.servico_id}&status=1`)
                .then(response => {
                    const prestadoresCarregados = response.data.results.map(prestador => ({
                        id: prestador.id,
                        prestador_id: prestador.prestador_id,
                        prestador_nome: prestador.dados_prestador.nome,
                        servico_procedimento_id: prestador.servico_procedimento_id,
                        valor: prestador.valor,
                        valor_parceiros: prestador.valor_parceiros,
                        valor_compra: prestador.valor_compra
                    }));
                    this.setState({ prestadores: prestadoresCarregados });
                })
                .catch(error => {
                    console.error('Erro ao carregar prestadores:', error);
                    
                    let erro_msg = 'Erro ao carregar prestadores da carteira, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    salvarPrestador = (index) => {
        const prestador = this.state.prestadores[index];
        const url = (prestador.id) ? `/pessoas/prestadores/servicos_procedimentos/${prestador.id}/` : '/pessoas/prestadores/servicos_procedimentos/';
        const metodo = (prestador.id) ? 'put' : 'post';

        const valorFormatadoAPI = prestador.valor;
        const valorParceirosFormatadoAPI = prestador.valor_parceiros;
        const valorCompraFormatadoAPI = prestador.valor_compra;
    
        const dadosPrestador = {
            servico_procedimento_id: this.state.servico_id,
            prestador_id: prestador.prestador_id,
            valor: valorFormatadoAPI,
            valor_parceiros: valorParceirosFormatadoAPI,
            valor_compra: valorCompraFormatadoAPI
        };

        api({
            method: metodo,
            url: url,
            data: dadosPrestador,
        })
        .then(response => {
            // Se for um novo prestador, atualize o estado com a ID retornada pela API
            if (!prestador.id) {
                this.setState(prevState => {
                    const prestadoresAtualizados = [...prevState.prestadores];
                    prestadoresAtualizados[index].id = response.data.id;
                    return { prestadores: prestadoresAtualizados };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = (prestador.id) ? 'Prestador atualizado com sucesso' : 'Prestador cadastrado com sucesso';

            MySwal.fire({
                title: 'Sucesso!',
                html: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o prestador, verifique os campos e tente novamente';   
            let content = '';         

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'prestador_id') {
                        content += `<br>&bull; Prestador: ${value}`;
                    }
                    if(key == 'servico_procedimento_id') {
                        content += `<br>&bull; Serviço: ${value}`;
                    }
                    if(key == 'valor') {
                        content += `<br>&bull; Valor: ${value}`;
                    }
                    if(key == 'valor_parceiros') {
                        content += `<br>&bull; Valor parceiros: ${value}`;
                    }
                    if(key == 'valor_compra') {
                        content += `<br>&bull; Valor compra: ${value}`;
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    };

    adicionarPrestador = () => {
        this.setState(prevState => ({
            prestadores: [...prevState.prestadores, { prestador_id: '', prestador_nome: '', valor: '', valor_parceiros: '', valor_compra: '' }],
        }));
    };

    removerPrestador = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover prestador?',
            text: "Tem certeza que deseja remover este prestador?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const prestador = this.state.prestadores[index];

                if (prestador.id) {

                    const url = `/pessoas/prestadores/servicos_procedimentos/${prestador.id}/`;
                    const metodo = 'put';

                    api({
                        method: metodo,
                        url: url,
                        data: {
                            status: false
                        }
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Prestador removido com sucesso';

                        MySwal.fire({
                            title: 'Sucesso!',
                            html: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            prestadores: prevState.prestadores.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o prestador, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        prestadores: prevState.prestadores.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'O prestador foi removido.',
                        'success'
                    );
                }
            }
        });
    };

    carregarDoencasVinculadas = (servico_id) => {
        const id = servico_id || this.state.servico_id;

        if(!id) return;

        api.get(`/servicos_procedimentos/doencas/?servico_procedimento_id=${id}`)
        .then(response => {
            this.setState({ vinculos_doencas: response.data.results || response.data });
        })
        .catch(error => {
            console.error("Erro ao carregar vínculos de doenças", error);
        });
    }

    carregarOpcoesDoencas = async (inputValue) => {
        if (!inputValue || inputValue.length < 3) return [];
        try {
            // Assumindo endpoint padrão de listagem de doenças
            const response = await api.get(`/doencas/?nome=${inputValue}&limit=20`);
            return response.data.results.map(d => ({
                value: d.id,
                label: `${d.nome}` // Ajuste conforme retorno da API de doenças
            }));
        } catch (error) {
            console.error('Erro ao buscar doenças:', error);
            return [];
        }
    };

    adicionarDoenca = () => {
        const { doenca_selecionada, servico_id } = this.state;

        if (!doenca_selecionada) {
            Swal.fire('Atenção', 'Selecione uma doença para vincular.', 'warning');
            return;
        }

        const jaExiste = this.state.vinculos_doencas.some(v => v.doenca_id === doenca_selecionada.value);
        if(jaExiste){
            Swal.fire('Atenção', 'Esta doença já está vinculada a este serviço.', 'info');
            return;
        }

        const payload = {
            servico_procedimento_id: servico_id,
            doenca_id: doenca_selecionada.value
        };

        this.setState({ loading: true });

        api.post('/servicos_procedimentos/doencas/', payload)
        .then(() => {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'success',
                title: <p>Vínculo adicionado com sucesso!</p>,
                showConfirmButton: false,
                timer: 1500
            });
            
            // Limpa seleção e recarrega lista
            this.setState({ doenca_selecionada: null, loading: false });
            this.carregarDoencasVinculadas();
        })
        .catch(error => {
            this.setState({ loading: false });
            let erro_msg = 'Erro ao vincular doença.';
            if(error.response && error.response.data && error.response.data.non_field_errors){
                erro_msg = error.response.data.non_field_errors[0];
            }
            Swal.fire('Erro', erro_msg, 'error');
        });
    }

// Remove um vínculo
removerDoenca = (id_vinculo) => {
    const MySwal = withReactContent(Swal);
    
    MySwal.fire({
        title: 'Remover vínculo?',
        text: "O serviço deixará de ser restrito a esta doença.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar'
    }).then((result) => {
        if (result.isConfirmed) {
            api.delete(`/servicos_procedimentos/doencas/${id_vinculo}/`)
            .then(() => {
                Swal.fire('Removido!', 'O vínculo foi removido.', 'success');
                this.carregarDoencasVinculadas();
            })
            .catch(() => {
                Swal.fire('Erro', 'Não foi possível remover o vínculo.', 'error');
            });
        }
    });
}

    formatarValorMonetario = (valor) => {
        let valorNumerico = valor.replace(/[^\d,]/g, '');
        valorNumerico = valorNumerico.replace(',', '.');
        return parseFloat(valorNumerico);
    }

    handlePrestadorChange = (index, event, fieldName) => {
        this.setState(prevState => {
            // Clonando o array de prestadores para não mutar o estado diretamente
            const prestadoresAtualizados = [...prevState.prestadores];
            
            // Atualizando o prestador específico baseado no fieldName
            if (fieldName === 'prestador_id') {
                prestadoresAtualizados[index] = { ...prestadoresAtualizados[index], prestador_id: event.value, prestador_nome: event.label };
            } 
            else if (fieldName === 'valor') {
                const { formattedValue, floatValue } = event;
                prestadoresAtualizados[index] = { ...prestadoresAtualizados[index], valor: this.formatarValorMonetario(formattedValue), valor_Float: floatValue };
            }
            else if (fieldName === 'valor_parceiros') {
                const { formattedValue, floatValue } = event;
                prestadoresAtualizados[index] = { ...prestadoresAtualizados[index], valor_parceiros: this.formatarValorMonetario(formattedValue), valor_parceirosFloat: floatValue };
            } 

            else if (fieldName === 'valor_compra') {
                const { formattedValue, floatValue } = event;
                prestadoresAtualizados[index] = { ...prestadoresAtualizados[index], valor_compra: this.formatarValorMonetario(formattedValue), valor_compraFloat: floatValue };
            } 
            else {
                prestadoresAtualizados[index] = { ...prestadoresAtualizados[index], [event.target.name]: event.target.value };
            }
    
            // Retornando o novo estado com o array de prestadores atualizado
            return { prestadores: prestadoresAtualizados };
        });
    };

    carregarPrestadores = async (inputValue) => {
        //if (inputValue.length < 3) return [];
        try {
            const response = await api.get(`/pessoas/prestadores/?nome=${inputValue}&limit=50`);
            const opcoes = response.data.results.map(prestador => ({
                value: prestador.id,
                label: `${prestador.nome} (${prestador.bairro || ''}, ${prestador.cidade || ''}/${prestador.uf || ''})`
            }));
            //this.setState({ opcoesClientes: opcoes });
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar prestadores:', error);
            return [];
        }
    };

    carregarProgramas= async (inputValue) => {
        try {
            const response = await api.get(`/programas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            /*Seleciona o programa atual*/
            const selectPrograma = response.data.results.filter((programa) => {
                if (programa.id == this.state.programa_id) {
                    this.setState({ 
                        programa_id: programa.id,
                        programa_nome: programa.nome
                    });
                }
            });
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas do cliente:', error);
            return [];
        }
    };

    excluirTermoAceitePdf = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: '<p>Deseja excluir o termo de aceite atual?</p>',
            text: 'Esta ação não pode ser desfeita.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed && this.state.servico_id) {
            formData.append('excluir_pdf', true);
            api({
                method: 'put',
                url: `/servicos_procedimentos/${this.state.servico_id}/`,
                data: formData,
            })
                .then(() => {
                MySwal.fire('Excluído!', 'O termo foi removido com sucesso.', 'success');
                this.setState({ termo_aceite_pdf: '', termo_aceite_pdf_upload: '' });
                })
                .catch(() => {
                MySwal.fire('Erro', 'Falha ao excluir o arquivo.', 'error');
                });
            }
        });
    };
    

    render(){
        return (
            <div>
                <Button 
                    variant="link" 
                    className="mb-2 p-0 text-decoration-none text-white"
                    onClick={() => this.props.router.navigate("/servicos")}
                >
                    <FaArrowLeft className="me-2" />
                    Voltar
                </Button>
                <Row className="align-items-center">
                    <Col sm={12} lg={12}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosServico" id="tabs-servico" className="aditus-tabs">
                    <Tab eventKey="dadosServico" title="Dados do Serviço/Procedimento">
                        <Card className="cardDestaque">
                            <Card.Body>                    
                                <Form onSubmit={this.enviaRegistro}>
                                    <h4>Dados do Serviço/Procedimento</h4>
                                    <Row>
                                        <Col xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Check 
                                                    type="switch"
                                                    id="custom-switch"
                                                    label={this.state.is_active ? "Ativo" : "Inativo"}
                                                    checked={this.state.is_active}
                                                    onChange={this.toggleStatusAtivo}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={5} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nome</Form.Label>
                                                <Form.Control type="text" name="nome" required placeholder="Nome" value={this.state.nome} onChange={this.handleChange} />    
                                                <Form.Text id="formNomeHelpBlock" className="text-danger">{this.state.nomeHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={3} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Tipo</Form.Label>
                                                <Form.Control as="select" name="tipo" value={this.state.tipo} required onChange={this.handleChange}>
                                                    <option value="">Tipo</option>
                                                    {Object.entries(tiposServicos).map(([sigla, nome]) => (
                                                        <option key={sigla} value={sigla}>{nome}</option>
                                                    ))}
                                                </Form.Control>
                                                <Form.Text id="formTipoHelpBlock" className="text-danger">{this.state.tipoHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        {/*<Col sm={3} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Valor</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="valor"
                                                    value={(this.state.valor) ? formatarValor(this.state.valor) : ''} 
                                                    onChange={this.handleChange}
                                                />
                                                <Form.Text id="formEanHelpBlock" className="text-danger">{this.state.eanHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>*/}
                                    </Row>
                                    <Row>
                                        <Col sm={2} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>É um serviço de monitoramento?{ajudaOpcao(AJUDA_OPCOES.monitoramento)}</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.servico_dados_monitoramento ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ servico_dados_monitoramento: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.servico_dados_monitoramento ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ servico_dados_monitoramento: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={2} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>É um serviço de vídeo conferência?{ajudaOpcao(AJUDA_OPCOES.video_conferencia)}</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.servico_video_conferencia ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ servico_video_conferencia: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.servico_video_conferencia ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ servico_video_conferencia: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={2} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>É um serviço de logística?{ajudaOpcao(AJUDA_OPCOES.logistica)}</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.servico_logistica ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ servico_logistica: true, permite_alterar_valor_agendamento: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.servico_logistica ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ servico_logistica: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={2} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Exige termo de aceite?{ajudaOpcao(AJUDA_OPCOES.termo_aceite)}</Form.Label>
                                                <div>
                                                <Button
                                                    variant={this.state.exige_termo_aceite ? "success" : "outline-secondary"}
                                                    onClick={() => this.setState({ exige_termo_aceite: true })}
                                                >
                                                    Sim
                                                </Button>
                                                {' '}
                                                <Button
                                                    variant={!this.state.exige_termo_aceite ? "danger" : "outline-secondary"}
                                                    onClick={() => this.setState({ exige_termo_aceite: false })}
                                                >
                                                    Não
                                                </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                         <Col sm={3} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Permite alterar valor do agendamento?{ajudaOpcao(AJUDA_OPCOES.alterar_valor)}</Form.Label>
                                                <div>
                                                <Button
                                                    variant={this.state.permite_alterar_valor_agendamento ? "success" : "outline-secondary"}
                                                    onClick={() => this.setState({ permite_alterar_valor_agendamento: true })}
                                                >
                                                    Sim
                                                </Button>
                                                {' '}
                                                <Button
                                                    variant={!this.state.permite_alterar_valor_agendamento ? "danger" : "outline-secondary"}
                                                    onClick={() => this.setState({ permite_alterar_valor_agendamento: false })}
                                                >
                                                    Não
                                                </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={3} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Ocultar serviço nas solicitações de exame?{ajudaOpcao(AJUDA_OPCOES.ocultar_exames)}</Form.Label>
                                                <div>
                                                <Button
                                                    variant={this.state.ocultar_solicitacao_exames ? "success" : "outline-secondary"}
                                                    onClick={() => this.setState({ ocultar_solicitacao_exames: true })}
                                                >
                                                    Sim
                                                </Button>
                                                {' '}
                                                <Button
                                                    variant={!this.state.ocultar_solicitacao_exames ? "danger" : "outline-secondary"}
                                                    onClick={() => this.setState({ ocultar_solicitacao_exames: false })}
                                                >
                                                    Não
                                                </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                         <Col sm={2} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>É um serviço de terapia?{ajudaOpcao(AJUDA_OPCOES.terapia)}</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.servico_terapia ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ servico_terapia: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button
                                                        variant={!this.state.servico_terapia ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ servico_terapia: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={3} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Permite atendimento frustrado?{ajudaOpcao(AJUDA_OPCOES.atendimento_frustrado)}</Form.Label>
                                                <div>
                                                    <Button
                                                        variant={this.state.permite_atendimento_frustrado ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ permite_atendimento_frustrado: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button
                                                        variant={!this.state.permite_atendimento_frustrado ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ permite_atendimento_frustrado: false, percentualCobrancaFrustradoHelper: '' })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>

                                        {this.state.permite_atendimento_frustrado && (
                                        <Col sm={3} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Percentual cobrado quando frustrado <span className="text-danger">*</span></Form.Label>
                                                <NumericFormat
                                                    customInput={Form.Control}
                                                    decimalSeparator=","
                                                    decimalScale={2}
                                                    suffix=" %"
                                                    allowNegative={false}
                                                    isAllowed={({ floatValue }) => floatValue === undefined || floatValue <= 100}
                                                    placeholder="0,00 %"
                                                    value={this.state.percentual_cobranca_frustrado}
                                                    onValueChange={(values) => this.setState({
                                                        percentual_cobranca_frustrado: values.value,
                                                        percentualCobrancaFrustradoHelper: '',
                                                    })}
                                                    isInvalid={!!this.state.percentualCobrancaFrustradoHelper}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {this.state.percentualCobrancaFrustradoHelper}
                                                </Form.Control.Feedback>
                                                <Form.Text className="text-muted">
                                                    Percentual do valor do serviço que será cobrado no atendimento frustrado (ex.: 30%).
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>
                                        )}

                                        {this.state.exige_termo_aceite && (
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                            <Form.Label>Termo PDF do Serviço</Form.Label>

                                            {/* Caso ainda não exista termo salvo */}
                                            {!this.state.termo_aceite_pdf ||
                                            typeof this.state.termo_aceite_pdf !== "string" ||
                                            this.state.termo_aceite_pdf === null ? (
                                                <>
                                                <Form.Control
                                                    ref={this.fileInputRef}
                                                    type="file"
                                                    accept="application/pdf"
                                                    onChange={(e) =>
                                                    this.setState({
                                                        termo_aceite_pdf_upload: e.target.files[0],
                                                        excluir_pdf: false,
                                                    })
                                                    }
                                                />

                                                {/* Mostra mensagem de confirmação se o usuário selecionou um arquivo */}
                                                {this.state.termo_aceite_pdf_upload && (
                                                    <div className="mt-2 small text-success d-flex align-items-center justify-content-between">
                                                    <span>
                                                        <FaCheck className="me-1" /> Arquivo pronto para envio:{" "}
                                                        <strong>{this.state.termo_aceite_pdf_upload.name}</strong>
                                                    </span>
                                                    <Button
                                                    variant="outline-danger"
                                                    size="sm"
                                                    onClick={() => {
                                                        this.setState({ termo_aceite_pdf_upload: '' });
                                                        if (this.fileInputRef.current) {
                                                        this.fileInputRef.current.value = ''; // limpa o input visualmente
                                                        }
                                                    }}
                                                    >
                                                    <FaTrash />
                                                    </Button>
                                                    </div>
                                                )}

                                                <Form.Text className="text-danger">
                                                    {this.state.termoAceitePDFHelper}
                                                </Form.Text>
                                                </>
                                            ) : (
                                                <>
                                                <div className="d-flex flex-wrap align-items-center gap-2 mt-2">
                                                    <Button
                                                    variant="light"
                                                    className="btn-sm"
                                                    onClick={() =>
                                                        this.setState({
                                                        excluir_pdf: true,
                                                        termo_aceite_pdf: "",
                                                        termo_aceite_pdf_upload: "",
                                                        })
                                                    }
                                                    >
                                                    <FaTrash /> Marcar para exclusão
                                                    </Button>

                                                    <Button
                                                    variant="light"
                                                    className="btn-sm"
                                                    onClick={() =>
                                                        window.open(
                                                        this.state.termo_aceite_pdf,
                                                        "_blank",
                                                        "noopener,noreferrer"
                                                        )
                                                    }
                                                    >
                                                    <FaEye /> Ver Termo Atual
                                                    </Button>
                                                </div>
                                                </>
                                            )}
                                            </Form.Group>
                                        </Col>
                                        )}          
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Descrição</Form.Label>
                                                <Form.Control 
                                                    as="textarea" 
                                                    required 
                                                    placeholder="Descrição" 
                                                    name="descricao"
                                                    value={this.state.descricao} 
                                                    onChange={this.handleChange} 
                                                    className="custom-textarea"
                                                />
                                                <Form.Text id="formDescricaoHelpBlock" className="text-danger">
                                                    {this.state.descricaoHelper}
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {this.state.erroLoadRegistro ? 
                                    <Alert variant="warning">
                                        {this.state.erroLoadRegistro}
                                    </Alert> : ''
                                    }                                      
                                    <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                        {this.state.loading ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : (
                                            <>
                                                <FaCheck className="me-1" /> Salvar
                                            </>
                                        )}
                                    </Button>
                                </Form> 
                            </Card.Body>                
                        </Card>
                    </Tab>
                    {this.state.servico_id && (
                        <Tab eventKey="prestadoresServico" title="Prestadores">
                            <Card className="cardDestaque">
                                <Card.Body>                    
                                    <Form onSubmit={this.ennviaPrestadorServico}>
                                        <h4>Prestadores do Serviço</h4>
                                        {this.state.prestadores.map((prestador, index) => (
                                            <div key={index} className="row-list">
                                                <Row>
                                                    <Col sm={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Prestador</Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={this.carregarPrestadores}
                                                                defaultOptions
                                                                name="prestador_id"
                                                                placeholder="Buscar prestador..."
                                                                noOptionsMessage={() => "Nenhum prestador encontrado"}
                                                                onChange={e => this.handlePrestadorChange(index, e, 'prestador_id')}
                                                                value={prestador.prestador_id ? { value: prestador.prestador_id, label: prestador.prestador_nome } : null}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={2} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Valor</Form.Label>
                                                            <NumericFormat
                                                                thousandSeparator={'.'}
                                                                decimalSeparator={','}
                                                                decimalScale={2}
                                                                fixedDecimalScale={true}
                                                                allowNegative={false}
                                                                prefix={'R$ '}
                                                                name="valor"
                                                                value={prestador.valor}
                                                                onValueChange={(values) => this.handlePrestadorChange(index, values, 'valor')}
                                                                className="form-control"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={2} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Valor parceiros</Form.Label>                                                       
                                                            <NumericFormat
                                                                thousandSeparator={'.'}
                                                                decimalSeparator={','}
                                                                decimalScale={2}
                                                                fixedDecimalScale={true}
                                                                allowNegative={false}
                                                                prefix={'R$ '}
                                                                name="valor"
                                                                value={prestador.valor_parceiros}
                                                                onValueChange={(values) => this.handlePrestadorChange(index, values, 'valor_parceiros')}
                                                                className="form-control"
                                                            />
                                                        </Form.Group>                                                       
                                                    </Col>
                                                    <Col sm={2} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Valor de Compra</Form.Label>                                                       
                                                            <NumericFormat
                                                                thousandSeparator={'.'}
                                                                decimalSeparator={','}
                                                                decimalScale={2}
                                                                fixedDecimalScale={true}
                                                                allowNegative={false}
                                                                prefix={'R$ '}
                                                                name="valor"
                                                                value={prestador.valor_compra}
                                                                onValueChange={(values) => this.handlePrestadorChange(index, values, 'valor_compra')}
                                                                className="form-control"
                                                            />
                                                        </Form.Group>                                                       
                                                    </Col>
                                                </Row>
                                                <Button variant="success" className="btn-sm" onClick={() => this.salvarPrestador(index)}><FaCheck className="me-1" /> Salvar Prestador</Button>&nbsp;&nbsp;
                                                <Button variant="danger" className="btn-sm ml-3" onClick={() => this.removerPrestador(index)}><FaTimes className="me-1" /> Remover Prestador</Button>
                                            </div>
                                        ))}
                                        <Button variant="secondary" onClick={this.adicionarPrestador}><FaStream /> Adicionar Prestador</Button>
                                    </Form> 
                                </Card.Body>                
                            </Card>
                        </Tab>
                    )}

                    {this.state.servico_id && (
                        <Tab eventKey="doencas" title="Vínculo com Doenças">
                            <Card className="cardDestaque border-0 shadow-sm">
                                <Card.Body>
                                    <div className="d-flex align-items-center mb-3">
                                        <h4 className="m-0 me-2">Restrição por Doenças</h4>
                                        
                                        {/* Lógica de Pluralização do Badge */}
                                        <span className="badge bg-light text-dark border">
                                            {this.state.vinculos_doencas.length} {this.state.vinculos_doencas.length === 1 ? 'Vinculada' : 'Vinculadas'}
                                        </span>
                                    </div>

                                    {/* Alerta Azul Restaurado */}
                                    <Alert variant="info" className="mb-4 border-info">
                                        <FaStream className="me-2"/>
                                        Ao vincular uma doença, este serviço aparecerá <strong>apenas</strong> nos atendimentos das doenças listadas abaixo.
                                        <br/>
                                        Caso a lista esteja vazia, o serviço é considerado <strong>global</strong> (disponível para qualquer caso).
                                    </Alert>

                                    {/* Formulário */}
                                    <Row className="g-2 align-items-end mb-4">
                                        <Col> 
                                            <Form.Label className="small fw-bold text-muted mb-1">Pesquisar Doença</Form.Label>
                                            <AsyncSelect
                                                cacheOptions
                                                loadOptions={this.carregarOpcoesDoencas}
                                                defaultOptions
                                                placeholder="Digite para buscar..."
                                                noOptionsMessage={() => "Nada encontrado"}
                                                loadingMessage={() => "..."}
                                                value={this.state.doenca_selecionada}
                                                onChange={(opt) => this.setState({ doenca_selecionada: opt })}
                                                isClearable
                                                styles={{
                                                    control: (base) => ({ ...base, minHeight: '38px', borderColor: '#dee2e6' })
                                                }}
                                            />
                                        </Col>
                                        <Col xs="auto">
                                            <Button 
                                                variant="success" 
                                                onClick={this.adicionarDoenca} 
                                                disabled={!this.state.doenca_selecionada || this.state.loading}
                                                style={{ minHeight: '38px' }}
                                            >
                                                {this.state.loading ? <span className="spinner-border spinner-border-sm"/> : <FaCheck />}
                                                <span className="d-none d-sm-inline ms-2">Vincular</span>
                                            </Button>
                                        </Col>
                                    </Row>

                                    {/* Lista Estilizada */}
                                    <h6 className="text-uppercase text-muted small fw-bold mb-2 ps-1">Doenças Ativas</h6>
                                    
                                    <div className="border rounded bg-white" style={{ maxHeight: '350px', overflowY: 'auto' }}>
                                        {this.state.vinculos_doencas.length === 0 ? (
                                            <div className="text-center py-5 text-muted">
                                                <FaNotesMedical size={24} className="mb-2 text-secondary opacity-25"/><br/>
                                                <small>Nenhuma restrição configurada.</small>
                                            </div>
                                        ) : (
                                            <ul className="list-group list-group-flush">
                                                {this.state.vinculos_doencas.map((item) => (
                                                    <li key={item.id} className="list-group-item d-flex justify-content-between align-items-center py-2 px-3 action-hover">
                                                        
                                                        <div className="d-flex align-items-center overflow-hidden me-3">
                                                            <div className="bg-light rounded-circle p-2 me-3 d-flex align-items-center justify-content-center text-success" style={{width: '32px', height: '32px', flexShrink: 0}}>
                                                                <FaNotesMedical size={14}/>
                                                            </div>
                                                            <div className="text-truncate">
                                                                <span 
                                                                    className="fw-medium text-dark d-block text-truncate" 
                                                                    title={item.dados_doenca ? item.dados_doenca.nome : ''}
                                                                    style={{ maxWidth: '100%' }}
                                                                >
                                                                    {item.dados_doenca ? item.dados_doenca.nome : 'Doença não identificada'}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        <Button 
                                                            variant="outline-danger" 
                                                            size="sm" 
                                                            className="border-0 rounded-circle p-2 d-flex align-items-center justify-content-center hover-shadow"
                                                            style={{ width: '32px', height: '32px', flexShrink: 0 }}
                                                            onClick={() => this.removerDoenca(item.id)}
                                                            title="Remover vínculo"
                                                        >
                                                            <FaTimes size={12} />
                                                        </Button>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </Card.Body>
                            </Card>
                        </Tab>
                    )}
                    {this.state.servico_id && (
                        <Tab eventKey="configuracoesServico" title="Configurações">
                            <ServicosConfiguracoes servicoId={this.state.servico_id} />
                        </Tab>
                    )}
                </Tabs>
            </div>
        )
    }
}

export default withRouter(ServicosEdit);
